/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Refer_SupervisorInputs */

const en_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer to Supervisor`)
};

const fr_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmettre au superviseur`)
};

const de_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenden Sie sich an den Vorgesetzten.`)
};

const it_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivolgersi al supervisore`)
};

const ru_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратитесь к руководителю.`)
};

const es_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulte al supervisor`)
};

const zh_cn2_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请咨询主管`)
};

const ja_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スーパーバイザーに問い合わせる`)
};

const hi_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर्यवेक्षक से संपर्क करें`)
};

const pt_pt2_work_order_publish_option_refer_supervisor = /** @type {(inputs: Work_Order_Publish_Option_Refer_SupervisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulte o supervisor.`)
};

/**
* | output |
* | --- |
* | "Refer to Supervisor" |
*
* @param {Work_Order_Publish_Option_Refer_SupervisorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_refer_supervisor = /** @type {((inputs?: Work_Order_Publish_Option_Refer_SupervisorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Refer_SupervisorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "de") return de_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "it") return it_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "ru") return ru_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "es") return es_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "ja") return ja_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "hi") return hi_work_order_publish_option_refer_supervisor(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_option_refer_supervisor(inputs)
	return en_work_order_publish_option_refer_supervisor(inputs)
});